module.exports = __webpack_public_path__ + "img/icon-vue.8bf2ec73.png";